export const deviceTypes  = [
    {
      label: 'AirAgri / PLD',
      value: 'airagri_pld',
    },
    {
      label: 'Zoleo (AirAgri)',
      value: 'zoleo_airagri',
    },
    {
      label: 'Zoleo (BYOD)',
      value: 'zoleo_byod'
    },  
    {
      label: 'Garmin (AirAgri)',
      value: 'garmin_airagri'
    },
    {
      label: 'Garmin (BYOD)',
      value: 'garmin_byod'
    },
    {
      label: 'Spot',
      value: 'spot'
    },
    {
      // You are not mistaken, although it has the value = hmd and the label as Bush Beacon, it is still an HMD device.
      // This is because the customer requested it to be displayed with the name Bush Beacon.
      label: 'Bush Beacon',
      value: 'hmd'
    },
    {
      label: 'Lora',
      value: 'lora'
    },
    {
      // Internal value 'neyos' is kept (matches backend device type, table name,
      // and API path). Customer-facing label is 'Bush Beacon v2' — the existing
      // HMD device is already labelled 'Bush Beacon' (see above comment).
      label: 'Bush Beacon v2',
      value: 'neyos'
    },
    {
      // Mobile app acting as a SafeFarm device. Auto-registered by the
      // app on first ping (POST /api/web/mobile-devices/report-position),
      // so this type is hidden from the AddDeviceModal dropdown.
      label: 'Mobile App',
      value: 'mobile',
      autoRegistered: true,
    },
    {
      // RealPTT PTT radio (GPS + SOS button). Poll-based, like Spot.
      // Customer-facing label is "AirAgri PTT" — the RealPTT brand is not
      // exposed in the UI. The `value` stays 'realptt' (backend device type).
      label: 'AirAgri PTT',
      value: 'realptt'
    }
]
